<template>
  <div>
    <section id="header">
      <div class="container">
        <div class="row align-items-center row-logo">
          <div class="col text-center " data-aos="fade-down" data-aos-duration="1500">
            <img src="/static/img/ncs/BeNeatLOGO.png" alt="" class="img-fluid beneat-logo">
            <img src="/static/img/ncs/ncs-logo.jpg" alt="" class="img-fluid ml-4 ncs-logo">
          </div>

        </div>

        <div class="row align-items-end">
          <div class="col text-center">
            <div class="mx-auto box">
              <a href="https://line.me/R/ti/p/@BeNeat" target="_blank"
                 class="btn btn-lg btn-warning text-white mb-4"
                 data-aos="fade-down" data-aos-duration="1500"
              >จองบริการ</a>
              <h1 class='title' data-aos="fade-down" data-aos-duration="1500">บริการ กำจัดไรฝุ่น</h1>
              <h2 class="mt-3" data-aos="fade-down" data-aos-duration="1500">"ให้เราดูแลคุณ และ คนที่คุณรัก"</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="alliance">
      <div class="container">
        <div class="row align-items-center">
          <div class="col text-center">
            <h2  data-aos="fade-down" data-aos-duration="1500">พันธมิตรของเราคือใคร ?</h2>
            <p  data-aos="fade-up" data-aos-duration="1500">
              BeNeat และ NATURAL CLEANING SYSTEM ร่วมบริการ กำจัดไรฝุ่น <br>
              บีนีทช่วยคุณคัดกรองบริษัททำความสะอาดชั้นนำที่มีความเชี่ยวชาญเฉพาะด้าน <br>
              และมีความรับผิดชอบสูง มาให้คุณเลือกใช้บริการ คุณจึงมั่นใจได้ว่าจะได้รับบริการที่ดีเยี่ยม
              ไม่ต่างจากการบริการของเรา
            </p>
          </div>
        </div>
      </div>
    </section>

    <section id="contents">
      <div class="container-fluid p-0">
        <div class="row no-gutters d-flex">
          <div class="col-12 col-md-8 d-flex align-items-end">
            <img src="/static/img/ncs/1.png" alt="" class="img-fluid"
                 data-aos="fade-right" data-aos-duration="1500"
            >
          </div>

          <div class="col-12 col-md-4 d-flex flex-column">
            <div class="box-clean d-flex flex-column flex-grow-1">
              <div class="content-text"  data-aos="fade-down" data-aos-duration="1500">
                <h2>TEST</h2>
                <p>ปริมาณฝุ่นและเชื้อโรคบนที่นอน</p>

                <div class="bottom-line mx-auto">
                  <hr>
                </div>
              </div>
            </div>
            <div class="row d-none d-lg-block d-xl-block">
              <div class="col-12 p-0 align-self-end">
                <img src="/static/img/ncs/2.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
        </div>


        <div class="row no-gutters d-flex content-bottom">
          <div class="col-12 col-md-4 d-flex flex-column">

            <div class="box-clean text-center flex-grow-1 order-2 order-md-1"
                 data-aos="fade-down" data-aos-duration="1500"
            >
              <h2>CLEAN</h2>
              <p>ทำความสะอาดที่นอนและโซฟา โดยเครื่องมือที่ถูกออกแบบมา<br> ให้มีแกนทุบ ซึ่งสามารถดึงฝุ่น
                และเชื้อโรคออกมาได้ลึกกว่า<br> เครื่องทั่วไปถึง 12 เท่า</p>

              <div class="bottom-line mx-auto">
                <hr>
              </div>

            </div>

            <div class="order-1 order-md-2">
              <img src="/static/img/ncs/4.png" alt="" class="img-fluid"
                   data-aos="fade-left" data-aos-duration="1500"
              >
            </div>

          </div>

          <div class="col-12 col-md-8 flex-column">

            <div class="">
              <img src="/static/img/ncs/3.png" alt="" class="img-fluid"
                   data-aos="fade-right" data-aos-duration="1500"
              >
            </div>

            <div class="row">
              <div class="col-12 col-md-6 d-flex flex-column p-0">
                <div class="box-clean text-center">
                  <h2>UVC</h2>
                  <p>ฆ่าเชื้อโรคและไรฝุ่นให้ตายก่อนจะทำความสะอาด</p>

                  <div class="bottom-line mx-auto">
                    <hr>
                  </div>
                </div>
                <div class="d-flex flex-grow-1">
                  <img src="/static/img/ncs/5.png" alt="" class="img-fluid"
                       data-aos="fade-down" data-aos-duration="1500"
                  >
                </div>
              </div>
              <div class="col-12 col-md-6 p-0 d-flex">
                <img src="/static/img/ncs/6.png" alt="" class="img-fluid"
                     data-aos="fade-right" data-aos-duration="1500"
                >
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>


    <section id="recheck">
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-12 col-md-4">

            <div class="box-clean text-center flex-grow-1 order-2 order-md-1"
                 data-aos="fade-left" data-aos-duration="1500">
              <h2>RECHECK</h2>
              <p>ทำความสะอาดอีกครั้งหนึ่ง<br>เพื่อให้เห็นถึงความแตกต่าง ระหว่างครั้งแรกกับครั้งที่สอง</p>

              <div class="bottom-line mx-auto">
                <hr>
              </div>

            </div>

          </div>

          <div class="col-12 col-md-8 content-right p-5 p-md-0">
            <div class="d-flex align-items-center justify-content-center flex-column h-100">
              <div class="text-center" data-aos="fade-down" data-aos-duration="1500">
                สำหรับการจองใช้บริการ หรือสอบถามข้อมูลเพิ่มเติม<br>คุณลูกค้าสามารถ ทำการคลิกที่ปุ่มด้านล่าง<br>เพื่อนัดหมายการใช้บริการ<br>
                หรือ โทร <a href="tel:+6621131138" class="text-dark"> 02-113-1138 </a> , <a href="tel:+66927572999" class="text-dark"> 092-7572999 </a> เพื่อติดต่อฝ่ายบริการของเรา
              </div>
              <a href="https://line.me/R/ti/p/@BeNeat" target="_blank"
                 class="btn btn-lg btn-warning text-white mt-4"
                 data-aos="fade-down" data-aos-duration="1500"
              >จองเลย</a>

            </div>
          </div>
        </div>
      </div>

    </section>


    <section id="before-after">
      <div class="row">
        <div class="col-12">
          <div class="content d-flex justify-content-center align-items-center flex-column">
            <h1 class="text-center" data-aos="fade-down" data-aos-duration="1500">BEFORE & AFTER</h1>
            <p data-aos="fade-up" data-aos-duration="1500">รูปก่อน-หลังทำความสะอาด</p>
          </div>
        </div>
      </div>
    </section>


    <section id="pic-before-after">
      <div class="container-fluid p-0">

        <div class="row no-gutters">
          <div class="col-12 col-md-4">
            <img src="/static/img/ncs/ba1.png"
                 data-aos="fade-left" data-aos-duration="1500"
                 class="img-fluid">
          </div>

          <div class="col-12 col-md-4">
            <img src="/static/img/ncs/ba2.png"
                 data-aos="fade-down" data-aos-duration="1500"
                 class="img-fluid">
          </div>

          <div class="col-12 col-md-4">
            <img src="/static/img/ncs/ba3.png"
                 data-aos="fade-right" data-aos-duration="1500"
                 class="img-fluid">
          </div>
        </div>

      </div>
    </section>

    <section id="satisfaction">
      <div class="container-fluid p-0">
        <div class="row no-gutters content d-flex flex-column align-items-center justify-content-center">
          <div>
            <h3 data-aos="fade-down" data-aos-duration="1500">100% SATISFACTION GUARANTEED</h3>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  import AOS from 'aos'

  export default {
    name: 'Ncs',
    created () {
      AOS.init({
        once: true,
        disabled: 'mobile'
      })
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../static/sass/page/ncs.scss";
  @import "~aos/dist/aos.css";
</style>



// WEBPACK FOOTER //
// src/components/information/Ncs.vue